import { render, staticRenderFns } from "./comp-video.vue?vue&type=template&id=0fc53e5a&scoped=true&lang=pug&"
import script from "./comp-video.vue?vue&type=script&lang=js&"
export * from "./comp-video.vue?vue&type=script&lang=js&"
import style0 from "./comp-video.vue?vue&type=style&index=0&id=0fc53e5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc53e5a",
  null
  
)

export default component.exports